import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse } from '@app/_models';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReviewService {

  constructor(private http: HttpClient) { }

  getCertifyOp(projectId: number, subjectId: number, operationType:string): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(environment.apiUrl + 'operations/operation/active/' + projectId + '/' + subjectId+ '/' + operationType);
  }

  requestCertify(data: object): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(environment.apiUrl + 'operations/request', data);
  }

  getCertifyHistory(endpointId: number): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(environment.apiUrl + 'operations/history/entity/' + endpointId+'/REVIEW');
  }

  approve(data: object): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(environment.apiUrl + 'operations/complete', data);
  }

  rejected(data: object): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(environment.apiUrl + 'operations/complete', data);
  }

  abort(data: object): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(environment.apiUrl + 'operations/abort', data);
  }
}
